import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { SipService } from '../services/sip.service';
import { EMPTY, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DtmfDialogComponent } from '../dtmf-dialog/dtmf-dialog.component';
import { EveCall } from '../models/eve-call';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-dialpad',
  templateUrl: './dialpad.component.html',
  styleUrls: ['./dialpad.component.css'],
})
export class DialpadComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('remoteAudio') remoteAudio!: ElementRef<HTMLAudioElement>;

  phoneNumber: string = '';
  error: string = '';
  incomingCall: string = '';

  digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

  private remoteStreamSubscription?: Subscription;

  private activeCallsSubscription?: Subscription;
  private incomingCallsSubscription?: Subscription;
  private selectedCallSubscription?: Subscription;

  // Active calls from SIP service (calls with session state not Terminated)
  activeCalls: EveCall[] = [];
  incomingCalls: EveCall[] = [];


  public selectedCall: EveCall | null = null;
  constructor(private sipService: SipService, 
    private dialog: MatDialog,
    private snack: MatSnackBar
  ) {}

 ngOnInit() {
    // ✅ Subscribe to SIP.js updates

    this.remoteStreamSubscription = this.sipService.remoteStream$.subscribe(
      (stream) => {
        if (stream) {
          this.attachAudioStream(stream);
        }
      }
    );


    // Subscribe to active calls from SIP service
    this.activeCallsSubscription = this.sipService.activeCalls$.subscribe(
      (calls) => {
        this.activeCalls = calls;
      }
    );

    // Subscribe to incoming calls observable.
    this.incomingCallsSubscription = this.sipService.incomingCalls$.subscribe(
      (calls) => {
        this.incomingCalls = calls;
      }
    );

    this.selectedCallSubscription = this.sipService.selectedCall$.subscribe((call) => {
      this.selectedCall = call;
      
    });
  }

  ngAfterViewInit() {
    console.log(
      '🎧 Remote audio element initialized:',
      this.remoteAudio.nativeElement
    );
    if (this.remoteAudio?.nativeElement) {
      this.sipService.setAudioElement(this.remoteAudio.nativeElement); // ✅ Pass to sipService
    }
  }

  // ✅ Bind the remote audio stream to the audio element
  attachAudioStream(stream: MediaStream) {
    if (this.remoteAudio && this.remoteAudio.nativeElement) {
      this.remoteAudio.nativeElement.srcObject = stream;
    }
  }

  async makeCall() {

    try{
      if (!this.phoneNumber) {
        console.error('Cannot make call due to errors or empty number');
        throw new Error('Invalid call parameters');
      }
      // Initiate outgoing call via SIP service (it will add the call to the active calls list)
      const newCall = await this.sipService.makeCall(this.phoneNumber);
      // Clear dialpad input after initiating the call
      this.phoneNumber = '';

      if( this.selectedCall && this.selectedCall !== newCall){
        await this.selectedCall.holdCall();
      }

      this.sipService.setSelectedCall(newCall);
    }
    catch (error: any) {
      // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Message Content', life: 3000 });
      const errorMessage =  "Failed to make call: " +error.message;
      this.snack.open(errorMessage, 'Dismiss');
    }
  }
  // Call control methods per active call
  async acceptCall(call: EveCall) {
    // Accept incoming call via SIP service
    try {
      if( this.selectedCall && this.selectedCall !== call){
        console.log('Holding current call before accepting new one', this.selectedCall);
        await this.selectedCall.holdCall();
      }
      this.sipService.setSelectedCall(call);
      await this.sipService.acceptCall(call);
    } catch (error: any) {
      const errorMessage = "Failed to accept call: " + error.message;
      this.snack.open(errorMessage, 'Dismiss');
    }
  }

  async rejectCall(call: EveCall) {
  // Reject incoming call via SIP service
  try {
    await this.sipService.rejectCall(call);
  } catch (error: any) {
    const errorMessage = "Failed to reject call: " + error.message;
    this.snack.open(errorMessage, 'Dismiss');
  }
}

  async toggleHold(call: EveCall) {
    if (call.isOnHold) {
      try
      {
        await call.unholdCall();
        if (this.sipService.hasSelectedCall()) {
          await this.sipService.getSelectedCall()?.holdCall();
          this.sipService.setSelectedCall(call);
        }
      }
      catch(error: any){
        const errorMessage = "Failed to unhold call: " + error.message;
        this.snack.open(errorMessage, 'Dismiss');
      }
    } else {
      try
      {
        await call.holdCall();
        if (this.sipService.getSelectedCall() === call) {
          this.sipService.setSelectedCall(null);
        }
      }
      catch(error: any){
        const errorMessage = "Failed to hold call: " + error.message;
        this.snack.open(errorMessage, 'Dismiss');
      }
    }
  }

  async endCall(call: EveCall) {
    try {
      await this.sipService.endCall(call);
      if(this.selectedCall === call) {
        this.sipService.setSelectedCall(null);// Clear selected call if it was ended
      }
    } catch (error: any) {
      const errorMessage = "Failed to end call: " + error.message;
      this.snack.open(errorMessage, 'Dismiss');
    }
  }

  openDtmfDialog(call: EveCall) {
    this.dialog.open(DtmfDialogComponent, {
      width: '250px',
      data: { call: call }
    });
  }

  addDigit(digit: string) {
    this.phoneNumber += digit;
  }

  deleteDigit() {
    if (this.phoneNumber.length > 0) {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
    }
  }

  // async startRecording() {
  //   await this.sipService.startRecording();
  // }

  // stopRecording() {
  //   this.sipService.stopRecording();
  // }

  // async playRecording() {
  //   await this.sipService.playRecording();
  // }

  


  // async selectThisCall(call: EveCall) {
  //   try {
  //     await this.sipService.selectCall(call);
  //     this.selectedCall = call; // ✅ Update selected call
  //   } catch (error: any) {
  //     const errorMessage = "Failed to select call: " + error.message;
  //     this.snack.open(errorMessage, 'Dismiss');
  //   }
  // }


  clearInput() {
    this.phoneNumber = ''; 
  }


  get hasCalls(): boolean {
  return this.activeCalls.length > 0 || this.incomingCalls.length > 0;
}

  ngOnDestroy() {
    this.incomingCallsSubscription?.unsubscribe();
    this.activeCallsSubscription?.unsubscribe();
    this.remoteStreamSubscription?.unsubscribe(); // ✅ Prevent memory leaks

    this.selectedCallSubscription?.unsubscribe(); // ✅ Prevent memory leaks
  }
}
